import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

import Mesta from './prihlaska/mesta';
import Ostatni from './prihlaska/ostatni';
import Ubytovani from './prihlaska/ubytovani'; 

import Store from './prihlaska/store'; 

import loadedData from './prihlaska/autosave';

class Prihlaska extends React.Component {
    render() {
        this.zobrazeniOdeslani();
        if(this.state.zeme.length === 0) return null;
        return (
            <div>
                <div className="form-left">
                    <h2>Zvolený jazykový pobyt v zahraničí</h2>
                    {this.state.store.zeme.map((item, key) => {
                        return (
                            <div key={key}>
                                <div className="formRow zeme">
                                    <label>Země:</label> 
                                    <select name={`prihlaska[zeme][${key}][value]`} value={item.value} onChange={(e) => {item.value = e.target.value}} required>
                                        <option value="">-- Nejdříve zvolte zemi --</option>
                                        {this.state.zeme.map((zeme, zemeKey) => {
                                            return <option key={zemeKey}>{zeme}</option> 
                                        })}
                                    </select>
                                </div>
                                {item.value !== "" &&
                                    <div>
                                        <Mesta zeme={item} zemeKey={key} store={this.state.store} />
                                        
                                    </div>
                                }

                            </div>
    
                        );
                    })}
                    {this.state.store.vyplnenyPrvniKurz() && !this.state.store.zvolenyJuniorKurz() &&
                        <Ubytovani 
                            idSkoly={this.state.store.zeme[0].mesta[0].skoly[0].value}
                            idMesta={this.state.store.zeme[0].mesta[0].value}
                            kurzNastup={this.state.store.prvniNastupniTerminKurzu()}
                            kurzDelka={this.state.store.delkaStudiaCelkem()}
                            store={this.state.store} />
                    }
                </div>
                {/*this.state.store.vyplnenyPrvniKurz() &&
                    <div className="form-right">
                        <Ubytovani 
                            idSkoly={this.state.store.zeme[0].mesta[0].skoly[0].value}
                            idMesta={this.state.store.zeme[0].mesta[0].value}
                            kurzNastup={this.state.store.prvniNastupniTerminKurzu()}
                            kurzDelka={this.state.store.delkaStudiaCelkem()}
                            store={this.state.store} />
                    </div>
                */}
                <div className="clear"></div>
                {this.state.store.vyplnenyPrvniKurz() &&
                    <Ostatni store={this.state.store} />
                }
            </div>
        );
    }

    constructor(props) {
        super(props);

        let store = new Store();
        
        this.state = {
            zeme: [],
            store: store
        }
    }

    componentDidMount() {
        axios.get(this.state.store.apiUrl, {params: {seznam: "zeme"}})
            .then((response) => {
                
                this.setState({
                    zeme: response.data
                });
            })
            .catch((error) => {
                Sentry.captureException(error);
                alert("Došlo k neočekáváné chybě(#A1) při načítání zemí. Prosím kontaktujte nás přímo.")
            });

        this.state.store.setOnUpdate = this.forceUpdate.bind(this);
        this.state.store.setLoadedData(loadedData);
        if(document.location.hostname === "www.australie-studium.cz" && Object.keys(loadedData).length === 0) {
            this.state.store.zeme[0].value = "Austrálie";
        }
    }

    zobrazeniOdeslani = () => {
        if(this.state.store.vyplnenyPrvniKurz()) {
            document.getElementById("prihlaska-odeslani").style.display = "block";
        } else {
            document.getElementById("prihlaska-odeslani").style.display = "none";
        }
    }

}

Sentry.init({
  dsn: "https://daa911f0313a4cb5aa834264ee26d6d7@sentry.io/1331362"
});

ReactDOM.render(
    <Prihlaska></Prihlaska>,
    document.getElementById('prihlaska-app')
);


// WEBPACK FOOTER //
// ./resources/prihlaska.js